import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

import Actions from './Actions';
import { getMessage, getStatus, getLocalFormattedTime } from './utils';

const Row = ({ order, index, fetchOrders }) => {
  const { groupId, groupRecords } = order;
  const [open, setOpen] = useState(false);
  const [sites, setSitesList] = useState([]);

  useEffect(() => {
    if (groupId) {
      const temp = [order].concat(groupRecords);
      temp.sort((a, b) => (a.currentSite > b.currentSite && 1) || -1);
      setSitesList(temp);
    }
  }, []);

  const getTagStyles = color => {
    return {
      background: color,
      color: 'white',
      textAlign: 'center',
      fontWeight: 'bold',
      padding: '2px',
      width: '60px',
      fontSize: '12px',
      borderRadius: '2px',
      margin: '0 auto'
    };
  };

  const getBgColor = isChildOrder => {
    if (isChildOrder) {
      return '#fff9ef';
    }
    if (index % 2 === 0) {
      return '#f9f1ff';
    }
    return '#ffffff';
  };

  const renderParentRow = () => {
    const { businessLegalName } = order;
    return (
      <Tr
        style={{ background: getBgColor(), cursor: 'pointer' }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          <div>
            {groupId}
            <div style={getTagStyles(`#4c2b6c`)}>Multi site</div>
          </div>
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          {businessLegalName}
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          {open ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}{' '}
        </Td>
      </Tr>
    );
  };

  const renderChildRow = (data, isChildOrder) => {
    const {
      orderId,
      businessLegalName,
      typeOfInstallation,
      updatedAt,
      currentSite
    } = data;
    const { statusToolTip, statusId } = getStatus(data);
    return (
      <Tr style={{ background: getBgColor(isChildOrder) }}>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          {orderId}
          {isChildOrder && (
            <div style={getTagStyles(`#6aca25`)}>{`Site: ${currentSite}`}</div>
          )}
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          {businessLegalName}
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          {typeOfInstallation}
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          {getLocalFormattedTime(updatedAt)}
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>{statusToolTip}</Td>
        <Td
          style={{ borderRight: '1px solid #e7e7e7', width: '30%' }}
        >{`${_.get(data, 'orderComments.0.text', '')}`}</Td>
        <Td style={{ width: '15%', borderRight: '1px solid #e7e7e7' }}>
          {getMessage(data)}
        </Td>
        <Td style={{ width: '20%', borderRight: '1px solid #e7e7e7' }}>
          <Actions status={statusId} order={data} fetchOrders={fetchOrders} />
        </Td>
      </Tr>
    );
  };

  return (
    <>
      {groupId ? (
        <>
          {renderParentRow()}
          {open && (
            <>
              {sites && sites.length ? (
                sites.map(data => renderChildRow(data, true))
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ) : (
        renderChildRow(order, false)
      )}
    </>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
